// 判断浏览器类型：Android/iOS
function getOSType () {
  if (/(Android)/i.test(navigator.userAgent)) {
    return 'Android'
  } else if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
    return 'IOS'
  }else{
    return 'PC'
  }
}
// 判断是否是微信浏览器
function isWeixin () {
  let res=location.href.indexOf('type')
  if(res!=-1){
    return false
  }
  if (/(micromessenger)/i.test(navigator.userAgent)) {
    return true
  } else {
    return false
  }
}
sessionStorage.setItem('isWeixin',isWeixin())
sessionStorage.setItem('OSType',getOSType())